import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-security',
  standalone: true,
  templateUrl: './rt-icon-security.component.html',
  styleUrls: ['./rt-icon-security.component.scss']
})
export class RtIconSecurityComponent {
  @Input() width: number | string = 14;
  @Input() height: number | string = 17;
}
